// extracted by mini-css-extract-plugin
export var copyableField = "_r0-4";
export var customerBadge = "_r0-0";
export var customerInfoTitle = "_r0-2";
export var details = "_r0-1";
export var dropdownContainer = "_r0-5";
export var dropdownImage = "_r0-6";
export var editAssigneeForm = "_r0-a";
export var editButton = "_r0-3";
export var email = "_r0-7";
export var hidden = "_r0-d";
export var input = "_r0-8";
export var saveButton = "_r0-b";
export var shopifyIcon = "_r0-c";
export var suggestionBadge = "_r0-e";
export var suggestionText = "_r0-f";
export var username = "_r0-9";